import React from "react";

const HeaderForm = () => {
  return (
    <div class="relative w-1/4 flex flex-row border-black border-[1.5px] rounded-full my-auto">
      <img src="/Search.svg" className="scale-[0.55]"></img>
      <input
        class="my-2  text-sm w-10/12 text-gray-900 rounded-lg bg-gray-50 bg-none outline-0"
        type="text"
        placeholder="Search Location or Property name"
      />
    </div>
  );
};

export default HeaderForm;
